var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNrgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4420_45735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#00E676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0026 3.79688L17 8.86132L12.0004 13.9227L10.0002 11.8982L13.0002 8.86132L12.0004 7.84882L8.00009 11.8982L12.0004 15.9475L18.0002 9.87333L20 11.8982L12.0004 19.9969L4 11.8982L12.0026 3.79688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9984 23.5984C18.4049 23.5984 23.5984 18.4049 23.5984 11.9984C23.5984 5.59193 18.4049 0.398438 11.9984 0.398438C5.59193 0.398438 0.398438 5.59193 0.398438 11.9984C0.398438 18.4049 5.59193 23.5984 11.9984 23.5984Z",
    stroke: "#00E676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4420_45735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNrgIcon);
export default __webpack_public_path__ + "static/media/nrg-icon.dbcd2f11c92cd0c938e2e0c06d141fa5.svg";
export { ForwardRef as ReactComponent };